"use strict";

function IM_Google_Map( element ) {
	this.element          = element;
	this.mapInstance      = null;
	this.markersInstances = [];

	// Find markers before map init.
	const $markers = element.querySelectorAll( ".marker" );

	// Create map instance.
	this.mapInstance = new google.maps.Map(
		element,
		{
			zoom: parseInt( element.getAttribute( "data-zoom" ) ) || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		}
	);

	// Add markers.
	for ( const $marker of $markers ) {
		this.initMarker( $marker );
	}

	// Center map based on markers.
	this.centerMap();
}

IM_Google_Map.prototype.initMarker = function ( element ) {
	// Create marker instance.
	const marker = new google.maps.Marker(
		{
			map: this.mapInstance,
			position: {
				lat: parseFloat( element.getAttribute( "data-lat" ) ),
				lng: parseFloat( element.getAttribute( "data-lng" ) )
			}
		}
	);

	// Append to reference for later use.
	this.markersInstances.push( marker );

	// If marker contains HTML, add it to an infoWindow.
	if ( element.innerHTML ) {
		const infoWindow = new google.maps.InfoWindow(
			{
				content: element.innerHTML
			}
		);

		google.maps.event.addListener(
			marker,
			"click",
			() => {
				infoWindow.open( this.mapInstance, marker );
			}
		);
	}
}

IM_Google_Map.prototype.centerMap = function () {
	const bounds = new google.maps.LatLngBounds();

	for ( const marker of this.markersInstances ) {
		bounds.extend(
			{
				lat: marker.position.lat(),
				lng: marker.position.lng()
			}
		);
	}

	if ( this.markersInstances.length === 1 ) {
		this.mapInstance.setCenter( bounds.getCenter() );
	} else {
		this.mapInstance.fitBounds( bounds );
	}
}
